import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import NavHorizontal from '../../../components/lib/NavHorizontal/NavHorizontal';
import { messages } from '../../../constants/AccessibilityConstants';
import { FilterNavTypeLinks, FilterNavTypes } from '../../../constants/FilterTypeNav';
import { createBEM } from '../../../lib/utils/css';

import './FilterTypeNav.scss';

class FilterTypeNav extends React.PureComponent {
  static propTypes = {
    updateUrlState: PropTypes.func,
    activeUrl: PropTypes.string.isRequired,
    baseUrl: PropTypes.string.isRequired,
    artistId: PropTypes.string,
    parentComponentName: PropTypes.oneOf(['search', 'addedHeader']),
    isColdStartWelcome: PropTypes.bool,
    filterTypes: PropTypes.array.isRequired,
    // itemWrapper used to pass in a wrapper element to such as a Coachmark
    // Use itemWrapperProps.filterType to specify which item should be wrapped
    itemWrapper: PropTypes.node,
    itemWrapperProps: PropTypes.object,
    itemWrapperOnClose: PropTypes.object,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  state = {
    navLinks: [],
  };

  componentWillMount() {
    this.updateNavState(this.props.activeUrl);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeUrl !== this.props.activeUrl) {
      this.updateNavState(nextProps.activeUrl);
    }
  }

  filterNavTypeLink = (baseUrl, filterType, currentFilterType) => {
    const filterNavTypeLink = FilterNavTypeLinks[filterType];
    const itemWrapper =
      filterType === (this.props.itemWrapperProps && this.props.itemWrapperProps.filterType)
        ? this.props.itemWrapper
        : null;

    return {
      url: baseUrl + '/' + filterType,
      label: <FormattedMessage {...filterNavTypeLink.label} />,
      isActive: currentFilterType === filterType,
      qaTag: filterNavTypeLink.qaTag,
      itemWrapper,
      itemWrapperProps: this.props.itemWrapperProps,
      itemWrapperOnClose: this.props.itemWrapperOnClose,
    };
  };

  updateNavState = activeUrl => {
    let currentFilterType = activeUrl ? activeUrl.substring(1) : '';
    if (this.props.artistId) {
      // If we're on a specific artist page
      currentFilterType = FilterNavTypes.ARTISTS;
    }
    if (activeUrl === this.props.baseUrl) {
      // If we're on base page
      currentFilterType = FilterNavTypes.ALL;
    }
    const navLinks = this.props.filterTypes.map(filterType => {
      return this.filterNavTypeLink(this.props.baseUrl, filterType, currentFilterType);
    });
    this.setState({ navLinks });
  };

  getLastUrlSegment = link => {
    const splitUrl = link.split('/');
    return `/${splitUrl[splitUrl.length - 1]}`;
  };

  onLinkClicked = link => {
    const activeUrl = this.getLastUrlSegment(link);
    if (this.props.updateUrlState) {
      this.props.updateUrlState(activeUrl);
    } else {
      this.context.router.push(link);
    }
    this.updateNavState(activeUrl);
    // Focus on filter helper.
    const searchKeyboardControls = document.getElementById('searchKeyboardControls');
    if (searchKeyboardControls) {
      searchKeyboardControls.focus();
    }
  };

  render() {
    const { parentComponentName, isColdStartWelcome } = this.props;
    const classes = createBEM('FilterTypeNav', {
      [parentComponentName]: !!parentComponentName,
      coldStartWelcome: isColdStartWelcome,
    });
    // Give search a custom label when it's being used to filter search results.
    const searchAriaLabel =
      messages.filterSearchResults && messages.filterSearchResults.defaultMessage;
    if (this.state.navLinks.length) {
      return (
        <div className={classes}>
          <NavHorizontal
            links={this.state.navLinks}
            ariaLabel={parentComponentName === 'search' ? searchAriaLabel : null}
            onLinkClicked={this.onLinkClicked}
          />
        </div>
      );
    }
    return null;
  }
}

export default FilterTypeNav;
